import React from "react";
import { Link } from "react-router-dom";

function SubscriptionDetails() {
  return (
    <div className="h-full w-full grid place-items-center">
      <div className="text-center">
        <h2 className="text-[2rem] font-medium">
          Your Subscription Has been Expired
        </h2>
        <p className="text-[10px] font-light">
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry.
        </p>
      </div>
      <img src="/assets/items/subscription-img.png" alt="" />
      <Link
        to={"/subscriptions"}
        className="bg-[#5C1895] text-white max-w-[15rem] w-full px-2 py-1 rounded mx-auto text-center"
      >
        Subscribe Now
      </Link>
    </div>
  );
}

export default SubscriptionDetails;
